import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PartnershipService from 'components/partnership/_index';

var Partnership = function Partnership() {
  return /*#__PURE__*/_jsx(PartnershipService, {});
};

export default Partnership;